module.exports = __webpack_public_path__ + "images/emoji/bike.b5245f0425cd70a77910.png";